import { Form, FormItemProps, Input } from 'antd';
import React from 'react';
import { isPassword } from 'util/check';

const LoginRules: FormItemProps['rules'] = [
  {
    required: true,
    message: '请输入密码'
  }
];

const NewRules: FormItemProps['rules'] = [
  {
    validator: (_: any, value: string) => (isPassword(value) ? Promise.resolve() : Promise.reject(new Error('输入密码需8-16位字母/数字/符号至少包含2种')))
  }
];

const ConfirmRules: FormItemProps['rules'] = [
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('两次输入的密码不一致'));
    }
  })
];

interface IProps {
  name?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  help?: FormItemProps['help'];
  type?: 'login' | 'new' | 'confirm';
  rules?: FormItemProps['rules'];
}

const LoginPasswordItem: React.FC<IProps> = ({ name = 'password', placeholder, help, type = 'login', rules, onChange }) => {
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\s/g, '');
    onChange && onChange(e.target.value);
  };

  const validateStatus = help ? 'error' : undefined;

  const _rules = rules ?? (type === 'new' ? NewRules : type === 'confirm' ? ConfirmRules : LoginRules);
  const _placeholder = placeholder ?? (type === 'new' ? '新密码（8-16位字母/数字/符号任意2种）' : type === 'confirm' ? '确认密码' : '请输入密码');

  return (
    <Form.Item
      name={name}
      validateStatus={validateStatus}
      help={help || undefined}
      rules={_rules}
      validateTrigger="onBlur"
      getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
    >
      <Input.Password maxLength={64} autoComplete="new-password" size="large" placeholder={_placeholder} onChange={onInputChange} />
    </Form.Item>
  );
};

export default LoginPasswordItem;
